var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.927,
    height: 15.907,
    viewBox: "0 0 15.927 15.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brand",
    transform: "translate(-177.826 -329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sell_FILL0_wght400_GRAD0_opsz48",
    d: "M13.513,19.55a1.223,1.223,0,0,1-1.728,0L4.338,12.1a1.042,1.042,0,0,1-.268-.417A1.5,1.5,0,0,1,4,11.229V5.192A1.155,1.155,0,0,1,5.192,4h6.037a1.7,1.7,0,0,1,.477.07,1.02,1.02,0,0,1,.437.268l7.408,7.408a1.224,1.224,0,0,1,0,1.767Zm-.814-.814L18.736,12.7,11.229,5.192H5.192v6.037ZM7.277,8.29A1.025,1.025,0,0,0,8,6.532a1.025,1.025,0,1,0-1.45,1.45.992.992,0,0,0,.725.308ZM5.192,5.192Z",
    transform: "translate(173.826 325)",
    fill: "#9bacb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.0e6d85e6a4e4173064e728b8957b0591.svg";
export { ForwardRef as ReactComponent };